module.exports = __webpack_public_path__ + "app-static/img/withdrawal-success.1d2c2510.png";